import React from 'react';

const educationData = [
  {
    degree: "State Engineer - Computer Engineering",
    duration: "2022 – 2024",
    institution: "Higher Institute of Administration and Computer Engineering, Rabat, Morocco",
    image: require("../assets/Images/ismagi.png"),
  },
  {
    degree: "Professional Bachelor’s - Information Systems and Big Data",
    duration: "2021 – 2022",
    institution: "Higher School of Technology of Salé, Salé, Morocco",
    image: require("../assets/Images/ests.jpg"),
  },
  {
    degree: "DUT – Computer Engineering",
    duration: "2017 – 2019",
    institution: "Higher School of Technology of Meknes, Meknes, Morocco",
    image: require("../assets/Images/estm.jpg"),
  },
];

const Skills = () => {
  return (
    <section id="Skills" className="text-gray-600 body-font">
      <div className="p-4 pt-0 mt-5 mx-auto md:p-5 md:mx-20 lg:mx-32 xl:mx-56">
        <div id="Skills" className="flex flex-wrap w-full mb-4 flex-col justify-center text-center md:mb-7">
          <h1 className="sm:text-4xl text-3xl font-medium mb-2 text-gray-900">
            Education
          </h1>
          <p
            data-aos="zoom-in"
            data-aos-duration="1000"
            data-aos-once="false"
            className="text-lg font-medium leading-relaxed text-dark-orange"
          >
            My Academic Journey
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {educationData.map((edu, index) => (
            <div
              key={index}
              className="flex flex-col items-center bg-white shadow-lg rounded-lg p-5 text-center hover:shadow-2xl transition-transform transform hover:scale-105"
            >
              <img
                src={edu.image}
                alt={`${edu.institution} logo`}
                className="w-24 h-24 object-cover mb-4 rounded-full border-4 border-gray-300"
              />
              <h2 className="text-xl font-semibold text-gray-800">{edu.degree}</h2>
              <p className="text-sm text-gray-500 mt-2">{edu.duration}</p>
              <p className="text-md mt-2 text-gray-600">{edu.institution}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
